import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault(); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If the email exists, a reset link has been generated.");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-background royal-radial">
      <div className="w-full max-w-md bg-card border border-border rounded-3xl p-8 shadow-xl">
        <Logo size={38} />
        <h1 className="font-display text-3xl font-bold tracking-tight mt-6">Forgot password</h1>
        <p className="text-muted-foreground mt-2 text-sm">Enter your email and we'll send you a reset link.</p>
        {sent ? (
          <div className="mt-6 rounded-2xl bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 p-4 text-sm">
            Check your email (or the server logs during demo) for the reset link.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label>Email</Label>
              <Input data-testid="forgot-email" required type="email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-1.5 rounded-xl h-11" />
            </div>
            <Button data-testid="forgot-submit" disabled={loading} className="w-full h-11 rounded-xl royal-gradient border-0 text-white">
              {loading ? "Sending..." : "Send reset link"}
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-sm text-primary hover:underline text-center">Back to sign in</Link>
      </div>
    </div>
  );
}
